import { createFileRoute } from "@tanstack/react-router";
import { MeetView } from "@/components/views";
import type { RouterAppContext } from "@/utils/custom-types";

export const Route = createFileRoute("/$workspaceId/meets/$channelId")({
	component: RouteComponent,
});

function RouteComponent() {
	const { workspaceId, channelId } = Route.useParams();
	const { session, currentWorkspace } =
		Route.useRouteContext() as RouterAppContext;
	
	return (
		<MeetView
			workspaceId={workspaceId}
			channelId={channelId}
			channel={channel}
			session={session}
			currentWorkspace={currentWorkspace}
		/>
	);
}
